/* 
 * Version: 1.0.0
 * Date: 2025-01-08 15:30:00
 * Description: React entry point for Calibration Tracker
 * Changes: Initial version
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);